export const mockApiResponse = {
  buckets: [
    {
      id: "1",
      bucketName: "arkiv",
      bucketSize: 654443,
      objects: 96555,
      location: "no-east",
      replicated: "Yes",
      properties: "Object lock 90, Versioning",
      accountName: "st99999-atlantic",
      created: "2026-03-02 19:32",
    },
    {
      id: "2",
      bucketName: "beregninger",
      bucketSize: 124442,
      objects: 442,
      location: "no-west",
      replicated: "No",
      properties: "Versioning",
      accountName: "st99999-atlantic",
      created: "2025-11-05 08:31",
    },
    {
      id: "3",
      bucketName: "en-backup",
      bucketSize: 36211,
      objects: 233732,
      location: "no-west",
      replicated: "No",
      properties: "",
      accountName: "st88888-nordic",
      created: "2026-01-10 10:04",
    },
    {
      id: "4",
      bucketName: "mtjenester",
      bucketSize: 279991,
      objects: 13400095,
      location: "no-west",
      replicated: "Yes",
      properties: "Versioning",
      accountName: "st77777-cloud",
      created: "2021-11-14 16:07",
    },
    {
      id: "5",
      bucketName: "nasuni",
      bucketSize: 339999,
      objects: 985444,
      location: "no-west",
      replicated: "No",
      properties: "Object lock 60",
      accountName: "st99999-atlantic",
      created: "2019-06-29 12:43",
    },
    {
      id: "6",
      bucketName: "logs-prod",
      bucketSize: 789123,
      objects: 12000000,
      location: "se-stockholm",
      replicated: "Yes",
      properties: "Versioning",
      accountName: "st55555-prod",
      created: "2024-07-21 14:12",
    },
    {
      id: "7",
      bucketName: "logs-dev",
      bucketSize: 12345,
      objects: 45234,
      location: "se-stockholm",
      replicated: "No",
      properties: "",
      accountName: "st55555-dev",
      created: "2024-02-11 09:22",
    },
    {
      id: "8",
      bucketName: "media-assets",
      bucketSize: 999999,
      objects: 8452342,
      location: "dk-copenhagen",
      replicated: "Yes",
      properties: "Object lock 30, Versioning",
      accountName: "st22222-media",
      created: "2023-12-01 18:45",
    },
    {
      id: "9",
      bucketName: "backup-eu",
      bucketSize: 456789,
      objects: 2233445,
      location: "de-frankfurt",
      replicated: "No",
      properties: "Object lock 90",
      accountName: "st11111-backup",
      created: "2022-03-15 07:55",
    },
    {
      id: "10",
      bucketName: "analytics-data",
      bucketSize: 888888,
      objects: 9999999,
      location: "fi-helsinki",
      replicated: "Yes",
      properties: "Versioning",
      accountName: "st33333-analytics",
      created: "2025-09-30 22:10",
    },
    {
      id: "11",
      bucketName: "temp-storage",
      bucketSize: 54321,
      objects: 1234,
      location: "no-east",
      replicated: "No",
      properties: "",
      accountName: "st99999-atlantic",
      created: "2026-04-01 11:11",
    },
    {
      id: "12",
      bucketName: "archive-2020",
      bucketSize: 777777,
      objects: 654321,
      location: "no-east",
      replicated: "No",
      properties: "Object lock 90",
      accountName: "st99999-atlantic",
      created: "2020-01-01 00:00",
    },
  ],
};
